// extracted by mini-css-extract-plugin
module.exports = {"search-field":"location-search-box_search-field__3OPlv","search-field-input":"location-search-box_search-field-input__hzAx1"};